import doc                            from '@widesk-core/decorators/doc';
import WebsiteServiceModel            from '@/models/WebsiteServiceModel';
import StandPageModel                 from '@/models/services/website/StandPageModel';
import StandPageValidationStatusModel from '@/models/services/website/StandPageValidationStatusModel';

export default class StandPageValidationStatusHistoryModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'standPage': id;
		'standPageValidationStatus': string;
	};

	private declare _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	static get path(): string {
		return 'stand_page_validation_status_histories/{?id}';
	}

	@doc.model(StandPageModel) declare standPage: StandPageModel;
	@doc.model(StandPageValidationStatusModel)
	declare standPageValidationStatus: StandPageValidationStatusModel;
	@doc.string declare note: string;
}
